import React, {useEffect} from 'react';
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import ToTop from "../components/ToTop";
import Footer from "../components/Footer";
import PeraturanContent from "../contents/PeraturanContent";

const Peraturan = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header />
            <CustomeNavbar />
            <PeraturanContent />
            <ToTop />
            <Footer />
        </div>
    );
};

export default Peraturan;